import { storyblokEditable } from '@storyblok/react/rsc';
import StoryblokRichText from '@/components/StoryblokRichText';

const RichText = ({ blok }) => (
  <div {...storyblokEditable(blok)}>
    <StoryblokRichText content={blok.content} className="text-16 sm:text-18" />
  </div>
);

export default RichText;
